import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { servicesData } from '../../data/servicesData';
import { Bot } from 'lucide-react';

const gridClasses = {
    1: "xl:col-span-1 xl:row-span-1",
    2: "xl:col-span-1 xl:row-span-1",
    3: "xl:col-span-1 xl:row-span-2",
    4: "xl:col-span-1 xl:row-span-1",
    5: "xl:col-span-1 xl:row-span-1",
    6: "xl:col-span-2 xl:row-span-1",
    7: "xl:col-span-1 xl:row-span-1",
};

const OnlineService = () => {

    const { t } = useTranslation()

    return (
        <div className='py-12 bg-white dark:bg-dark'>

            <div className='media'>

                <p className='mb-8 font-bold xl:text-2xl
                              dark:text-dark-text text-xl'>
                    {t('online_services')}
                </p>

                <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 auto-rows-[220px] gap-6'>

                    {servicesData?.map((d) => (

                        d.external ? (

                            <a
                                href={d.link}
                                key={d.id}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={gridClasses[d.id]}
                            >

                                <div
                                    className='relative text-center card h-full rounded-xl
                                               shadow-sm border border-text
                                               transition-transform duration-500 ease-out
                                               hover:scale-[1.04] hover:shadow-xl overflow-hidden'
                                    style={{
                                        backgroundImage: `url(${d.backgroundImage})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                    }}
                                >

                                    <div className="absolute inset-0 bg-black opacity-40 rounded-xl"></div>

                                    <div className='relative flex flex-col text-white
                                                    justify-center items-center h-full'>

                                           <Bot size={40} />    

                                        <p className='mt-4 font-bold text-xl'>
                                            {d.name}
                                        </p>

                                    </div>

                                </div>

                            </a>

                        ) : (

                            <Link
                                to={d.link}
                                key={d.id}
                                className={gridClasses[d.id]}
                            >

                                <div
                                    className='relative text-center card h-full rounded-xl
                                                shadow-sm border border-text p-8
                                                transition-transform duration-500 ease-out
                                                hover:scale-[1.04] hover:shadow-xl overflow-hidden'
                                    style={{
                                        backgroundImage: `url(${d.backgroundImage})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                    }}
                                >

                                    <div className="absolute inset-0 bg-black opacity-40 rounded-xl"></div>

                                    <div className='relative flex flex-col text-white
                                                    justify-center items-center h-full'>

                                        <span>{d.icon}</span>

                                        <p className='mt-4 font-bold text-xl'>
                                            {t(d.name)}
                                        </p>

                                    </div>

                                </div>

                            </Link>

                        )

                    ))}

                </div>

            </div>

        </div>
    );
};

export default OnlineService;